<script lang="ts">
	import { beforeNavigate, afterNavigate } from '$app/navigation';

	import { Tween } from 'svelte/motion';
	import { cubicOut } from 'svelte/easing';

	interface Props {
		/** Colour of the nav indicator */
		colour?: string;
		/** Height of the nav indicator */
		height?: string;
		/** Wait time before the progress bar starts (in ms) */
		waitTime?: number;
	}

	let { colour = 'currentColor', height = '0.5rem', waitTime = 200 }: Props = $props();

	// Duration of transitions in milliseconds
	const duration = 400;

	// Smoothed progress value
	const tweenedProgress = new Tween(0, { duration, easing: cubicOut });

	let opacity = $state(0);

	beforeNavigate(() => {
		setTimeout(() => {
			void tweenedProgress.set(0, { duration: 0 });
			opacity = 1;
			void tweenedProgress.set(0.7);
		}, waitTime);
	});

	afterNavigate(() => {
		void tweenedProgress.set(1);
		setTimeout(() => {
			opacity = 0;
		}, duration - 200);
		setTimeout(() => {
			void tweenedProgress.set(0, { duration: 0 });
		}, duration);
	});
</script>

<div class="fixed left-0 top-0 z-[999] w-full md:h-1" style:height>
	<!-- This is the actual progress bar -->
	<div
		class="h-full w-[var(--width)] transition-opacity duration-300"
		style:background-color={colour}
		style:opacity
		style:--width="{tweenedProgress.current * 100}%"
	></div>
</div>
